<template>
    <div>
        <section>
            <div class="inner row5">
                <h1 class="boardTitle">제품 · 서비스 검색</h1>
                <div>
                    <div class="serviceSearchform" >
                        <p>
                            고객님이 찾으시는 제품과 서비스를 검색해주세요.
                        </p>
                        <div class="searchBox">
                            <input type="text" v-model="searchText" @keyup.enter="onClickSearch"/>
                            <button @click="onClickSearch"></button>
                        </div>
                    </div>

                    <div class="searchResultTxtBox">
                        <p>
                            <span>
                                ‘{{ $route.query.searchText }}’
                            </span>
                            검색 결과
                        </p>
                    </div>

                    <div class="searchResultCon mgBt100">
                        <div class="searchResultTitle flex">
                            <h3>
                                제품
                            </h3>
                            <p>검색결과 : 총
                                <span>
                                    {{ productData.totalCnt }}
                                </span>
                                건
                            </p>
                        </div>
                        <hr>
                        
                        <div class="searchResultBody">
                            <router-link :to="'/productDetail/'+product.CATEGORY_IDX+'/'+product.COMMON_IDX" v-for="(product, index) in productData.items" :key="index">
                                <div class="searchResultItem">
                                    <div class="imgBox">
                                        <img :src="product.MAIN_FILE" alt="">
                                    </div>
                                    <div class="title">
                                        <p>
                                            {{product.CATEGORY_NAME}}
                                        </p>
                                    </div>
                                    <div class="subContent">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th>제조구분</th>
                                                    <td>{{product.MANUFACTURE}}</td>
                                                </tr>
                                                <tr>
                                                    <th>업체명</th>
                                                    <td>{{product.COMPANY}}</td>
                                                </tr>
                                                <tr>
                                                    <th>제품명</th>
                                                    <td>{{product.NAME}}</td>
                                                </tr>
                                                <tr>
                                                    <th>사용제안공간</th>
                                                    <td>
                                                        <p>
                                                            {{product.PLACE_NAME}}
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        <div class="tableContainer">
                            <div class="sampleTemplate">
                                <paginate
                                    v-model="productData.currentPage"
                                    :page-count="productNavCnt"
                                    :page-range="3"
                                    :margin-pages="2"
                                    :click-handler="onClickProductPagenation"
                                    :prev-text="'‹'"
                                    :next-text="'›'"
                                    :container-class="'pagination b-pagination newPagination'">
                                </paginate>
                            </div>
                        </div>
                    </div>

                    <div class="searchResultCon mgBt100">
                        <div class="searchResultTitle flex">
                            <h3>
                                서비스
                            </h3>
                            <p>검색결과 : 총
                                <span>
                                    {{ serviceData.totalCnt }}
                                </span>
                                건
                            </p>
                        </div>
                        <hr>
                        
                        <div class="searchResultBody">
                            <router-link :to="'/serviceDetail/'+service.CATEGORY_IDX+'/'+service.COMMON_IDX" v-for="(service, index) in serviceData.items" :key="index">
                                <div class="searchResultItem">
                                    <div class="imgBox">
                                        <img :src="service.MAIN_FILE" alt="">
                                    </div>
                                    <div class="title">
                                        <p>
                                            {{service.CATEGORY_NAME}}
                                        </p>
                                    </div>
                                    <div class="subContent">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <th>생활 구분</th>
                                                    <td>{{service.LIFE}}</td>
                                                </tr>
                                                <tr>
                                                    <th>업체명</th>
                                                    <td>{{service.COMPANY}}</td>
                                                </tr>
                                                <tr>
                                                    <th>서비스명</th>
                                                    <td>{{service.NAME}}</td>
                                                </tr>
                                                <tr>
                                                    <th>사용제안대상</th>
                                                    <td>
                                                        <p>
                                                            {{service.TARGET}}
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        <div class="tableContainer">
                            <div class="sampleTemplate">
                                <paginate
                                    v-model="serviceData.currentPage"
                                    :page-count="serviceNavCnt"
                                    :page-range="3"
                                    :margin-pages="2"
                                    :click-handler="onClickServicePagenation"
                                    :prev-text="'‹'"
                                    :next-text="'›'"
                                    :container-class="'pagination b-pagination newPagination'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
        
    </div>   
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'ServiceSearchResult',
    mounted(){
        this.getProduct()
        this.getService()
    },
    data(){
        return {
            searchText: this.$route.query.searchText ? this.$route.query.searchText : "",
            productData:{
                items : null,
                totalCnt: 0,
                currentPage: 1,
                // static data
                sortBy: 'IDX',
                sortDesc: false,
                perPage: 9,
            },
            serviceData:{
                items : null,
                totalCnt: 0,
                currentPage: 1,
                // static data
                sortBy: 'IDX',
                sortDesc: false,
                perPage: 9,
            }
        }
    },
    computed: {
        productNavCnt : function(){
            if(this.productData.totalCnt % this.productData.perPage == 0) return this.productData.totalCnt / this.productData.perPage
			else return Math.floor(this.productData.totalCnt / this.productData.perPage) + 1;
        },
        serviceNavCnt : function(){
            if(this.serviceData.totalCnt % this.serviceData.perPage == 0) return this.productData.totalCnt / this.productData.perPage
			else return Math.floor(this.serviceData.totalCnt/this.serviceData.perPage) + 1;
        }
    },
    methods:{
        ...mapActions('product', [
            'requestProductByKeyword'
        ]),
        ...mapActions('service', [
            'requestServiceByKeyword'
        ]),
        getProduct(){
            this.productData.items = []
            this.productData.totalCnt = 0

            this.requestProductByKeyword({
                searchText : this.searchText,
                currentPage: this.productData.currentPage,
                perPage: this.productData.perPage,
                sortBy: this.productData.sortBy,
                sortDesc: this.productData.sortDesc
            })
            .then((response) =>{
                if(response.status === 200){
                    this.productData.items = response.data.items;
                    this.productData.totalCnt = response.data.totalCnt;

                    if(this.productData.items == null){
                        this.productData.items = [];
                        this.productData.totalCnt = 0;
                    }
                }
                else{
                    this.$alert('알림', '데이터를 가져올 수 없습니다.')      
                }
            })
            .catch(() => {
                this.$alert('알림', '통신을 실패했습니다.')  
            })
        },
        getService(){
            this.serviceData.items = []
            this.serviceData.totalCnt = 0

            this.requestServiceByKeyword({
                searchText : this.searchText,
                currentPage: this.serviceData.currentPage,
                perPage: this.serviceData.perPage,
                sortBy: this.serviceData.sortBy,
                sortDesc: this.serviceData.sortDesc
            })
            .then((response) =>{
                if(response.status === 200){
                    this.serviceData.items = response.data.items;
                    this.serviceData.totalCnt = response.data.totalCnt;

                    if(this.serviceData.items == null){
                        this.serviceData.items = [];
                        this.serviceData.totalCnt = 0;
                    }
                }
                else{
                    this.$alert('알림', '데이터를 가져올 수 없습니다.')      
                }
            })
            .catch(() => {
                this.$alert('알림', '통신을 실패했습니다.')  
            })
        },
        onClickSearch(){
            if(this.searchText !== this.$route.query.searchText){
                this.$router.replace({ path:'/serviceSearchResult', query: { searchText: this.searchText }})
                
                this.productData.currentPage = 1
                this.serviceData.currentPage = 1

                this.getProduct()
                this.getService()
            }
        },
        onClickProductPagenation (pageNum) {
            this.productData.currentPage = pageNum;
            this.getProduct();
        },
        onClickServicePagenation (pageNum) {
            this.serviceData.currentPage = pageNum;
            this.getService();
        }
    }
}

</script>

<style scoped>
    a {
        color: #272727;
    }
    h3 {
        margin: 0 0 16px 0;
    }
    
</style>

<style>
</style>

